export default __webpack_public_path__ + "static/media/divisions_import_template.58970b2e.csv";